var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import useMeasure from 'react-use-measure';
import { useDropdownPosition } from '../../hooks/use-dropdown-position';
import styles from './styles.module.scss';
export var TooltipContent = function (_a) {
    var _b;
    var _c;
    var children = _a.children, _d = _a.placement, placement = _d === void 0 ? 'top' : _d, _e = _a.alignment, alignment = _e === void 0 ? 'center' : _e, _f = _a.isOpen, isOpen = _f === void 0 ? false : _f, triggerRef = _a.triggerRef;
    var _g = useMeasure(), contentRef = _g[0], contentBounds = _g[1];
    var _h = useState(false), shouldRender = _h[0], setShouldRender = _h[1];
    var dropdownPosition = useDropdownPosition(shouldRender, triggerRef === null || triggerRef === void 0 ? void 0 : triggerRef.current, contentBounds, placement, alignment, 'auto', false);
    // triggers animation
    useEffect(function () {
        if (isOpen) {
            setShouldRender(true);
        }
    }, [isOpen]);
    var handleTransitionEnd = function () {
        if (!isOpen) {
            setShouldRender(false);
        }
    };
    if (!shouldRender)
        return null;
    return ReactDOM.createPortal(_jsxs("div", { ref: contentRef, className: classNames(styles.content, (_b = {},
            _b[styles.exiting] = !isOpen && shouldRender,
            _b)), style: __assign(__assign({}, dropdownPosition), { opacity: isOpen ? (_c = dropdownPosition === null || dropdownPosition === void 0 ? void 0 : dropdownPosition.opacity) !== null && _c !== void 0 ? _c : 1 : 0 }), onTransitionEnd: handleTransitionEnd, children: [children, _jsx("div", { className: classNames(styles.arrow, styles["arrow-".concat(placement)]) })] }), document.getElementById('app-modals-portal'));
};
